
import { mapGetters, mapActions } from "vuex";
import CatalogBlock from "~/components/blocks/CatalogBlock";
import UiFilter from "@/components/UI/UiFilter.vue";

export default {
  components: {
    CatalogBlock,
    UiFilter,
  },
  props: {
    currentCollection: {
      type: Object,
      default: () => {},
    },
    pageData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filterSchema: {
        min_cost_from: "",
        max_cost_to: "",
      },
      filterData: null,
      sortByOptions: [
        // { label: "POPULARITY", value: "popularity" },
        // { label: "FEATURED", value: "featured" },

        { label: this.$t("recommended"), value: "" },
        { label: this.$t("priceFromLowestToHighest"), value: "price|asc" },
        { label: this.$t("priceFromHighestToLowest"), value: "price|desc" },
      ],
    };
  },
  async fetch() {
    await this.fetchFiltersData();
    this.filterSchema = {
      min_cost_from: "",
      max_cost_to: "",
    };
    this.filterData = JSON.parse(JSON.stringify(this.filterList));
    // Object.values(this.filterData).forEach((el) => {
    //   el.sort((a, b) => a?.sort_order - b?.sort_order);
    // });
    // console.log("this.filterData - ", this.filterData);
    Object.entries(this.filterData).forEach(([key, value]) => {
      if (
        !this.currentCollection &&
        value &&
        value.length &&
        key !== "materials_settings"
      ) {
        this.filterSchema[key] = value.reduce((acc, el) => {
          if (key === "collections") {
            acc.push({
              label: el.mixedTranslation?.title,
              url: el.slug,
            });
          } else if (key === "categories") {
            acc.push({
              ...el,
              label: el.mixedTranslation?.title,
              value: el.sku,
            });
          } else if (key === "materials" && el.show_filter) {
            acc.push({
              ...el,
              label: el.mixedTranslation?.title,
              value: el.sku,
            });
          }
          return acc;
        }, []);
      } else if (
        this.currentCollection &&
        value &&
        value.length &&
        key !== "materials_settings"
      ) {
        this.filterSchema[key] = value.reduce((acc, el) => {
          if (key === "collections") {
            acc.push({
              label: el.mixedTranslation?.title,
              url: el.slug,
            });
          } else if (key === "categories") {
            acc.push({
              ...el,
              label: el.mixedTranslation?.title,
              value: el.sku,
            });
          } else if (key === "materials") {
            if (el.collections.includes(this.currentCollection.id)) {
              acc.push({
                ...el,
                label: el.mixedTranslation?.title,
                value: el.sku,
              });
            }
          }
          return acc;
        }, []);
      }
    });
  },
  computed: {
    ...mapGetters({
      getMaterialsCategories: "general/getMaterialsCategories",
      filterList: "general/getFiltersData",
    }),
  },
  methods: {
    ...mapActions({
      fetchFiltersData: "general/fetchFiltersData",
    }),
  },
};
